import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';
import {BasicAgency} from "./rest-api.service";
import {PatientData} from '../components/types/patient-data';

@Injectable({
  providedIn: 'root'
})
export class PatientService {
  private _currentPatient:PatientData;
  private _currentAgency:BasicAgency;
  private patientChangeSource = new Subject<PatientData>();

  patientChanged$ = this.patientChangeSource.asObservable();

  constructor() { }

  get currentPatient(): PatientData {
    return this._currentPatient;
  }

  set currentPatient(value: PatientData) {
    this._currentPatient = value;
    this.patientChangeSource.next(value);
  }

  get currentAgency(): BasicAgency {
    return this._currentAgency;
  }

  set currentAgency(value: BasicAgency) {
    this._currentAgency = value;
  }
}
